import React, { useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { useUISettings } from '../context/UISettingsContext';
import { useNotification } from '../hooks/useNotification';
import { useSocket } from '../hooks/useSocket';
import { Notification } from './common/Notification';
import { AuthScreen, CredentialsDisplay } from './auth';
import { ChatInterface } from './chat/ChatInterface';
import { AppLockScreen } from './common/AppLockScreen';
import * as Modals from './modals';

export function MainApp() {
  const { isAuthenticated, isLoading, signupResult } = useAuth();
  const { appLocked, pinCheckDone, showNewToken, newSessionToken } = useUISettings();
  const { notification } = useNotification();
  useSocket(); // Initialize socket connection

  // Show loading state
  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-100">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500 mx-auto"></div>
          <p className="mt-4 text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  // Show credentials display after signup
  if (signupResult) {
    return (
      <>
        {notification.show && (
          <Notification 
            message={notification.message} 
            type={notification.type} 
            onDismiss={() => {}} 
          />
        )}
        <CredentialsDisplay />
      </>
    );
  }

  return (
    <>
      {notification.show && (
        <Notification 
          message={notification.message} 
          type={notification.type} 
          onDismiss={() => {}} 
        />
      )}
      
      <Modals.PrivateKeyModal />
      <Modals.TwoFAModal />
      <Modals.ContactModal />
      <Modals.PinModal />
      <Modals.SelfDestructModal />
      <Modals.NewTokenModal 
        isOpen={showNewToken} 
        token={newSessionToken} 
        onClose={() => {}} 
      />
      <Modals.RecoveryCodesModal />
      <Modals.RecoverAccountModal />
      <Modals.ShowTokenModal />
      
      {appLocked && !pinCheckDone ? (
        <AppLockScreen />
      ) : !isAuthenticated ? (
        <AuthScreen />
      ) : (
        <ChatInterface />
      )}
    </>
  );
}